export default __webpack_public_path__ + "static/media/ikea.1a9a8b00.png";